import { Link } from 'react-router-dom';
import { ArrowRight, BarChart3, Gauge, MapPinned, MessageSquareText, Star, Timer, UsersRound, Wallet } from 'lucide-react';
import { Reveal, TiltCard } from '../components/motion';

const MEASURES = [
  { icon: MapPinned, title: 'Local rank positions', copy: 'Track Maps and Search placement by keyword and market, then compare after each change.', plan: 'Launch' },
  { icon: Gauge, title: 'Website visibility score', copy: 'Score any site against seven local-search signals and re-run it as you fix issues.', plan: 'Free' },
  { icon: UsersRound, title: 'Lead volume by source', copy: 'See which pages, campaigns, and channels actually produce inquiries.', plan: 'Growth' },
  { icon: Timer, title: 'Response speed', copy: 'Measure how fast each lead gets a first reply and flag anything past your target window.', plan: 'Revenue Partner' },
  { icon: MessageSquareText, title: 'Campaign performance', copy: 'Compare campaign activity and outcomes instead of guessing which message worked.', plan: 'Growth' },
  { icon: Star, title: 'Review generation', copy: 'Watch requests, new reviews, and response times in one reputation view.', plan: 'Revenue Partner' },
  { icon: BarChart3, title: 'Revenue and conversion', copy: 'Connect pipeline stages to closed revenue so effort maps to income.', plan: 'Revenue Partner' },
  { icon: Wallet, title: 'Source profitability', copy: 'Compare return by marketing source to decide where the next dollar goes.', plan: 'Revenue Partner' },
];

export default function Results() {
  return (
    <>
      <section className="page-hero">
        <Reveal className="page-hero-inner">
          <div className="section-tag">RESULTS</div>
          <h1>Measure what actually produces customers.</h1>
          <p>Data Tallied reports on the parts of local growth you can act on: where you rank, how fast you respond, which sources convert, and what that is worth.</p>
          <div className="page-hero-actions">
            <Link to="/free-tools" className="btn-primary">Get your baseline <ArrowRight size={16} /></Link>
            <Link to="/products" className="btn-ghost">See the reporting tools</Link>
          </div>
        </Reveal>
      </section>

      <section className="results-honesty">
        <Reveal className="results-honesty-inner">
          <h2>No invented case studies.</h2>
          <p>
            We do not publish made-up percentages or stock testimonials. The numbers that matter are the ones from your own
            market, so the honest starting point is a free scan of your site and a baseline of your current rankings.
            Everything below is a report the platform actually produces from your data.
          </p>
          <Link to="/free-tools#visibility-scan" className="btn-primary">Run the free visibility scan <ArrowRight size={16} /></Link>
        </Reveal>
      </section>

      <section className="results-measures">
        <Reveal className="section-header">
          <div className="section-tag">WHAT YOU CAN MEASURE</div>
          <h2 className="section-title">Reporting built around decisions.</h2>
          <p className="section-sub">Each report answers a question you can act on this week, and shows the plan that unlocks it.</p>
        </Reveal>
        <div className="results-grid">
          {MEASURES.map(item => {
            const Icon = item.icon;
            return (
              <TiltCard as="article" className="results-card" intensity={5} lift={5} key={item.title}>
                <span className="results-card-icon"><Icon size={18} /></span>
                <h3>{item.title}</h3>
                <p>{item.copy}</p>
                <span className={`results-plan${item.plan === 'Free' ? ' is-free' : ''}`}>{item.plan}</span>
              </TiltCard>
            );
          })}
        </div>
      </section>

      <section className="home-cta">
        <div className="home-cta-inner">
          <div>
            <div className="section-tag">YOUR NUMBERS, NOT OURS</div>
            <h2>Start measuring this week.</h2>
            <p>Run the free scan, save the result to an account, and track whether the work you do moves it.</p>
          </div>
          <div className="home-cta-actions">
            <Link to="/free-tools" className="btn-primary">Run a free scan <ArrowRight size={16} /></Link>
            <Link to="/pricing" className="btn-ghost">Compare plans</Link>
          </div>
        </div>
      </section>
    </>
  );
}
